import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import LanguageToggle from "../components/LanguageToggle";
import { BrandMark } from "../components/Logo";

export default function Login() {
  const { t } = useI18n();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (!r.ok) { setErr(r.error); return; }
    if (r.user.role === "super_admin") navigate("/admin/tenants");
    else navigate("/app/dashboard");
  };

  return (
    <div className="min-h-screen flex items-center justify-center grain relative px-4">
      <div className="absolute top-6 right-6 z-10"><LanguageToggle /></div>
      <Link to="/" className="absolute top-6 left-6 z-10" data-testid="brand-link">
        <BrandMark />
      </Link>
      <div className="w-full max-w-md glass rounded-3xl p-8 lg:p-10 anim-stagger relative">
        <h1 className="text-3xl font-extrabold text-white tracking-tight">{t("auth.login_title")}</h1>
        <p className="mt-2 text-sm text-slate-400">{t("auth.login_sub")}</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-400 font-bold">{t("auth.email")}</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-dark mt-1.5" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-400 font-bold">{t("auth.password")}</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-dark mt-1.5" />
          </div>
          {err && <div className="text-rose-400 text-sm" data-testid="login-error">{err}</div>}
          <button type="submit" disabled={busy} className="btn-primary w-full inline-flex items-center justify-center gap-2" data-testid="login-submit">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}
            {t("auth.submit_login")}
          </button>
          <div className="text-right">
            <Link to="/forgot-password" className="text-xs text-slate-400 hover:text-magenta transition" data-testid="forgot-link">{t("auth.forgot_link")}</Link>
          </div>
        </form>
        <p className="mt-6 text-sm text-slate-400 text-center">
          {t("auth.no_account")}{" "}
          <Link to="/signup" className="text-magenta hover:text-primary-hover font-semibold" data-testid="go-signup">{t("auth.go_signup")}</Link>
        </p>
      </div>
    </div>
  );
}
